import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/stores/authStore';
import { LogOut, Globe, Menu } from 'lucide-react';

interface NavbarProps {
  /** Apre il drawer di navigazione mobile (hamburger visibile solo sotto md) */
  onMenuClick: () => void;
}

export default function Navbar({ onMenuClick }: NavbarProps) {
  const { t, i18n } = useTranslation();
  const { logout } = useAuthStore();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'it' ? 'en' : 'it';
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  const handleLogout = () => {
    logout();
    // TODO: Call API to invalidate token
  };

  return (
    <header className="h-14 bg-white border-b border-dark-700 flex items-center px-4 md:px-8 gap-3">
      {/* Hamburger (solo mobile): apre il drawer di navigazione */}
      <button
        onClick={onMenuClick}
        className="md:hidden p-2 -ml-2 rounded-md text-dark-400 hover:bg-dark-800 hover:text-dark-200 transition-colors"
        aria-label="Menu"
      >
        <Menu size={20} />
      </button>

      {/* Spacer: spinge le azioni a destra (come il vecchio justify-end) */}
      <div className="flex-1" />

      {/* Language Toggle */}
      <button
        onClick={toggleLanguage}
        className="flex items-center gap-2 px-3 py-1.5 rounded-md text-dark-400 hover:bg-dark-800 hover:text-dark-200 transition-colors"
      >
        <Globe size={16} />
        <span className="text-sm font-medium uppercase">{i18n.language}</span>
      </button>

      {/* Logout */}
      <button
        onClick={handleLogout}
        className="flex items-center gap-2 px-3 py-1.5 rounded-md text-dark-400 hover:bg-error-50 hover:text-error-600 transition-colors"
      >
        <LogOut size={16} />
        <span className="text-sm font-medium">{t('auth.logout')}</span>
      </button>
    </header>
  );
}
